module.exports = __webpack_public_path__ + "img/SOLANA-logo.090b8f20.svg";